import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SystemMasterTabel from '../../Components/SystemMasterTabel/SystemMasterTabel';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';

const tempObj = {
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
};

function TestTypeMaster({ OpenReArrangeFunction }) {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const { testTypeMaster } = SystemMastersDetails;
  const { userInfo } = UserDetails;

  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;

  const [isLoadingTest, setIsLoadingTest] = useState(false);
  const [showTestType, setShowTestType] = useState(false);
  const [isTypeUnique, setIsTypeUnique] = useState(true);
  const [buttonDownTestType, setButtonDownTestType] = useState(true);
  const [testBtnDisable, setTestBtnDisable] = useState(false);
  const [addingTestType, setAddingTestType] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isTestType, setIsTestType] = useState(false);
  const [testTypeData, setTestTypeData] = useState([]);
  const [isUniqId, setIsUniqId] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);
  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'testType', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(userRights, 'masters', 'testType', 'delete');
  const testMaster = '/test-type-master';

  useEffect(() => {
    setTestTypeData(testTypeMaster);
    if (addingTestType) {
      setTestTypeData([
        ...testTypeMaster,
        {
          name: null,
          isEmpty: false,
          isNew: true,
          isActive: true,
          _id: '',
        },
      ]);
    }
  }, [testTypeMaster, addingTestType]);

  const callApi = async () => {
    setButtonDownTestType(!buttonDownTestType);
    setIsLoadingTest(true);
    buttonDownTestType ? setShowTestType(true) : setShowTestType(false);

    isEmpty(testTypeData) && (await dispatch(action.fetchTestTypeMaster()));
    setIsLoadingTest(false);
  };

  const handleChanged = (event, i) => {
    const { value } = event.target;
    if (value.length === 0 || value[0] !== ' ') {
      // Prevent starting with space
      const seasons = [...testTypeData];
      setIsUniqId([]);
      setIsTypeUnique(true);

      seasons[i] = {
        ...seasons[i],
        name: value,
        isEmpty: value === '',
        seqNumber: i,
      };

      const arr = [];
      const arrIndex = [];
      seasons.forEach((ele, ind) => {
        seasons.forEach((objs, index) => {
          if (ele.name === objs.name && ind !== index) {
            arr.push(ele);
            arrIndex.push(index);
          }
        });
      });

      if (!isEmpty(arr)) {
        const arrs = [...arrIndex];
        const removeArss = Math.min(...arrs);
        const newArr = arrIndex.filter((ele) => ele !== removeArss);
        setIsUniqId([...newArr]);
      }

      setIsTypeUnique(isEmpty(arr));
      let isDisableSeason = false;
      seasons.forEach((seasonElement) => {
        if (isEmpty(seasonElement?.name?.trim())) {
          isDisableSeason = true;
        }
      });
      setTestBtnDisable(isDisableSeason);
      setTestTypeData(seasons);
    }
  };

  const addSeasons = async () => {
    if (!showTestType) {
      setAddingTestType(true);
      setButtonDownTestType(!buttonDownTestType);
      setIsLoadingTest(true);
      buttonDownTestType ? setShowTestType(true) : setShowTestType(false);
      const sParams = {
        loggedInUserId,
      };
      isEmpty(testTypeData) && (await dispatch(action.getSeasonsDetails(sParams)));
      setIsLoadingTest(false);
    } else if (!isEmpty(testTypeData)) {
      setTestTypeData([...testTypeData, tempObj]);
    } else {
      setTestTypeData([tempObj]);
    }
  };

  const handleDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      testTypeData.splice(id, 1);
      let sids = false;
      testTypeData.forEach((seasonElement) => {
        if (isEmpty(seasonElement?.name?.trim())) {
          sids = true;
        }
      });
      setTestBtnDisable(sids);
      setIsTypeUnique(true);
      setIsUniqId([]);
      setTestTypeData([...testTypeData]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const saveSeasons = async () => {
    setIsTestType(true);
    if (!isEmpty(testTypeData)) {
      const emptyField = await testTypeData.filter((ssitem) => ssitem.name === null || ssitem.name === '');
      if (isEmpty(emptyField)) {
        const data = testTypeData.map((seasobj) => {
          return { ...seasobj, name: seasobj?.name?.trim() };
        });
        const seasonSaveParams = {
          loggedInUserId,
          testType: JSON.stringify(data),
          title: testMaster,
          section: 'masters',
          module: 'testType',
          action: 'addEdit',
        };
        setAddingTestType(false);
        await dispatch(action.saveToSystemMaster(seasonSaveParams, t));
        setTestTypeData([]);
        await dispatch(action.fetchTestTypeMaster());
        // post API
      } else {
        const newState = testTypeData.map((sSobj) => (sSobj?.isEmpty === false && sSobj.name === null ? { ...sSobj, isEmpty: true } : sSobj));
        setTestTypeData(newState);
      }
    }
    setIsTestType(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  useEffect(() => {
    const array = [];
    testTypeData.forEach((ele, index) => {
      testTypeData.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsTypeUnique(isEmpty(array));
      setIsUniqId([]);
    }
  }, [testTypeData]);

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const seasonParams = {
      loggedInUserId,
      testTypeId: deleteId,
      title: testMaster,
      section: 'masters',
      module: 'testType',
      action: 'delete',
    };
    await dispatch(action.deleteFromSystemMasters(seasonParams, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setTestTypeData([...testTypeMaster]);
    await dispatch(action.fetchTestTypeMaster());
  };

  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let ssn = {};
    testTypeData.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          title: testMaster,
        };
        ssn = data;
      }
    });
    ssn = { ...ssn, action: 'addEdit', section: 'masters', module: 'testType' };
    await dispatch(action.setActiveInactive(ssn, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
    setTestTypeData([...testTypeData]);
  };

  return (
    <>
      <SystemMasterTabel
        isLoading={isLoadingTest}
        setShow={showTestType}
        callApi={callApi}
        buttonDown={buttonDownTestType}
        mainData={testTypeData}
        handleChanged={handleChanged}
        addBtnClicked={addSeasons}
        deletPressed={handleDelete}
        onSave={saveSeasons}
        isDesabled={isTestType}
        title={t('TEST_TYPE_MASTER.TITLE')}
        masterAddEditAccess={MasterAddEditAccess}
        masterDeleteAccess={MasterDeleteAccess}
        inputName={t('TEST_TYPE_MASTER.INPUT_NAME')}
        activeInactiveClicked={activeInactiveClicked}
        btnDisable={testBtnDisable}
        isUnique={isTypeUnique}
        isUniqueId={isUniqId}
        OpenReArrangeFunction={OpenReArrangeFunction}
      />
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('TEST_TYPE_MASTER.DELETE_CONFIRMATION.TITLE')}
          message={t('TEST_TYPE_MASTER.DELETE_CONFIRMATION.MESSAGE')}
          toggle={() => setShowConfirmation(!showConfirmation)}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('TEST_TYPE_MASTER.ACTIVE_INACTIVE_CONFIRMATION.TITLE')}
          message={t('TEST_TYPE_MASTER.ACTIVE_INACTIVE_CONFIRMATION.MESSAGE')}
          toggle={() => setShowConfirmationAD(!showConfirmationAD)}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}

export default TestTypeMaster;
